import TestimonialPage from './TestimonialPage';
export default TestimonialPage;